module.exports = require("@swa-ui/shopping/src/forms/CarBookingForm/CarBookingForm.module.scss");